import Loadable from "../../react-loadable";
import WeaAssociativeSearchMult from "../base/wea-associative-search-mult";
import WeaAssociativeSearch from "../base/wea-associative-search";
import { getKeys } from "./util";

const Com = Loadable({
  loader: () => import("./Main"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

Com.getKeys = getKeys;
Com.WeaAssociativeSearchMult = WeaAssociativeSearchMult;
Com.WeaAssociativeSearch = WeaAssociativeSearch;
Com.urlOfIframeInDialogCallBack = {};

export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-browser/index.js